"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPage = void 0;
const React = require("react");
class MasterPage extends React.Component {
    constructor(props) {
        super(props);
    }
}
exports.MasterPage = MasterPage;
